export interface Environment {
    dev: {
        uploadUrl: string;
        surveyUrl: string;
    };
    qc: {
        uploadUrl: string;
        surveyUrl: string;
    };
    uat: {
        uploadUrl: string;
        surveyUrl: string;
    };
    production: {
        uploadUrl: string;
        surveyUrl: string;
    };
}

export const surveyForce: Environment = {
    dev: {
        uploadUrl: 'https://api-dev.vinid.dev/',
        surveyUrl: 'https://api-dev.vinid.dev/',
    },
    qc: {
        uploadUrl: 'https://api-uat.vinid.dev/',
        surveyUrl: 'https://api-qc.vinid.dev/',
    },
    uat: {
        uploadUrl: 'https://api-uat.vinid.dev/',
        surveyUrl: 'https://api-uat.vinid.dev/',
    },
    production: {
        uploadUrl: 'https://apex.vinid.net/',
        surveyUrl: 'https://apex.vinid.net/',
    },
};
export const surveyForceDev = {
    svf: surveyForce.dev,
};
export const surveyForceQC = {
    svf: surveyForce.qc,
};
export const surveyForceUAT = {
    svf: surveyForce.production,
};
export const surveyForceProd = {
    svf: surveyForce.production,
};
